module.exports = __webpack_public_path__ + "9df8fb6d0d5f9605e4307f8d5c91aaa8.mp4";